(ns minorodata.users.redirect-events
  (:require [re-frame.core :as re-frame]
            [re-posh.core :as re-posh]
            [minorodata.utils :refer [value-included]]))


(re-frame/reg-event-fx
  :users.events/auth-redirects
  (fn []
    (let [current-user @(re-posh/subscribe [:user/pull])
          default-route :overview]
      (condp value-included (:user/roles current-user)
        "admin" {:async-flow {:first-dispatch [:users.api/fetch-admin-data]
                              :rules          [{:when     :seen?
                                                :events   :users.api/fetch-admin-data-success
                                                :dispatch [:app.events/navigate default-route]}]}}

        "data-entry" {:dispatch-n [[:connections.api/fetch-warehouse-status]
                                   [:app.events/navigate :webforms]]}
        {:dispatch [:app.events/navigate default-route]}))))
